var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-around"},[_c('multiselect',{attrs:{"options":_vm.agents,"label":"nickname","trackBy":"id"},on:{"input":_vm.updateAgent},model:{value:(_vm.agent),callback:function ($$v) {_vm.agent=$$v},expression:"agent"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }